import { useParams } from "react-router-dom";
import UserInviteDisplay from "../../components/history/display/UserInviteDisplay";

const UserInvitePage = () => {
  const { hash } = useParams();

  return (
    <UserInviteDisplay hash={hash} />
  );
};

export default UserInvitePage;